import { useTranslation } from 'react-i18next'

interface Props {
  rows: Array<{ name: string; venues: number }>
  /** Kolik poboček celkem — proti tomu se měří délka pruhu. */
  totalVenues: number
}

/**
 * Kolik poboček má kterou naši službu aktivovanou. Pruh je podíl z celkového
 * počtu poboček, ne z největší služby — jinak by nejrozšířenější služba vždy
 * vypadala na 100 %, i kdyby ji mělo jen pár poboček.
 */
export function ServiceAdoption({ rows, totalVenues }: Props) {
  const { i18n } = useTranslation()
  const cs = i18n.language === 'cs'

  if (rows.length === 0) {
    return <div className="py-6 text-center text-sm text-ink-subtle">—</div>
  }

  const denominator = Math.max(1, totalVenues)

  return (
    <ul className="flex flex-col gap-2.5">
      {rows.slice(0, 7).map((r) => {
        const pct = Math.min(100, (r.venues / denominator) * 100)
        return (
          <li key={r.name} className="flex items-center gap-3">
            <span className="w-36 shrink-0 truncate text-sm text-ink" title={r.name}>
              {r.name}
            </span>
            <span className="h-2 min-w-0 flex-1 overflow-hidden rounded-full bg-surface-3">
              <span
                className="block h-full rounded-full bg-[var(--brand-primary)]"
                style={{ width: `${pct}%` }}
              />
            </span>
            <span className="w-24 shrink-0 text-right text-sm tabular-nums text-ink-subtle">
              {r.venues} {cs ? 'poboček' : 'venues'}
            </span>
          </li>
        )
      })}
    </ul>
  )
}
